import { IState } from '../../store';

export const selectDemandRequestPhone = (state: IState) => state.requestDemand.lastDemandRequest?.phone || '';
